import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const signup = (data) => axios.post(`${API}/supporters`, data);
export const getEvents = () => axios.get(`${API}/events`);
export const adminLogin = (password) => axios.post(`${API}/admin/login`, { password });
export const getSupporters = (token) =>
  axios.get(`${API}/admin/supporters`, { headers: { Authorization: `Bearer ${token}` } });
export const getStats = (token) =>
  axios.get(`${API}/admin/stats`, { headers: { Authorization: `Bearer ${token}` } });
export const trackVisit = () => axios.post(`${API}/track/visit`);
export const trackView = (key) => axios.post(`${API}/track/view`, { key });
export const deleteEvent = (token, id) =>
  axios.delete(`${API}/admin/events/${id}`, { headers: { Authorization: `Bearer ${token}` } });
export const createEvent = (token, data) =>
  axios.post(`${API}/admin/events`, data, { headers: { Authorization: `Bearer ${token}` } });
export const updateEvent = (token, id, data) =>
  axios.put(`${API}/admin/events/${id}`, data, { headers: { Authorization: `Bearer ${token}` } });
export const exportSupporters = (token) =>
  axios.get(`${API}/admin/export`, {
    headers: { Authorization: `Bearer ${token}` },
    responseType: "blob",
  });
